import useResizeObserver from 'hooks/use-resize-observer';
import { useTranslation } from 'hooks/use-translation';
import React, { FC } from 'react';
import styles from './styles.scss';

type IProps = {
	onClick?: () => void;
}

const FreeSection: FC<IProps> = (props) => {
	const { width } = useResizeObserver()
	const { transData } = useTranslation('happyKids.free')
	return (
		<section className={styles['ac-free']} id='free'>
			<div className={styles['ac-free-container']}>
				<img className={styles['free-img-1']} loading='lazy' src="https://web-data.zmlearn.com/image/rCxJY6KiuZGTxpQAryDpmT/banner_left_bg%402x.png" alt="" />
				<img className={styles['free-img-3']} loading='lazy' src={transData.banner_text} alt="" />
				<div className={styles['free-action']}>
					<img className={styles['free-img-4']} onClick={props.onClick} loading='lazy' src={transData.button} alt="" />

					<span className={styles['hand']}></span>
				</div>
				<img className={styles['free-img-2']} loading='lazy' src="https://web-data.zmlearn.com/image/uKMTd2FjoiHDHWNRxSh91n/rainbowbg%402x.png" alt="" />
			</div>
		</section>
	);

}

export default FreeSection
